import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {WarningButton, DefaultButton, Filter} from '../../../components';
import NonComplianceReasonsList from './NonComplianceReasonsList';

const Container = styled.div`
  margin: 1em;
`;

const Question = styled('div')`
  padding-bottom: 0.5em;
  
  & .question {
    padding-bottom: 1em;
  }
  & .title {
    font-weight: bold
  }
    
`;

const reasons = [
  'Failure to provide records for review', 
  'Incomplete Documentation',
  'Invalid Level I Part A (SMI) and/or Part B (ID/DD)',
  'Invalid Level I Part C (Categorical Determination)', 
  'Invalid Level II',
  'Late Level I', 
  'Late Level II', 
  'Level I not signed by MD, APRN, RN', 
  'Missing Level I', 
  'Missing Level II Evaluation', 
  'Missing Resident Review', 
  'Missing SMI/ID/DD determination', 
  'Specialized services indicated but not provided', 
  'Timeliness of SMI determination', 
  'Timeliness of ID/DD determination'];

class NonComplianceReasons extends React.Component {
  

  state = {showAddSection: false,
            currentSelection: '',
            reasons};

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedReasons && nextProps.selectedReasons.length > 0) {
      return {
        reasons: prevState.reasons.filter(r => !nextProps.selectedReasons.includes(r))
      };
    }

    // Return null to indicate no change to state.
    return null;
  }
  
  showAddSection = show => this.setState({showAddSection: show});

  cancelEdit = () => {
    this.showAddSection(false);
    this.setState({currentSelection: ''});
  }

  saveReason = () => { 
    this.props.onAdd(this.state.currentSelection);
    this.setState(state => ({showAddSection: false, currentSelection: '', reasons: state.reasons.filter(r => r !== state.currentSelection)}));
  }

  removeReason = (reason) => {
    this.props.onRemove(reason);
    this.setState(state => ({reasons: [...reasons, reason]}));
  }

  onReasonChange = value => this.setState({currentSelection: value});

  render() {
    const {currentSelection, reasons} = this.state;
    const {selectedReasons, disabled} = this.props;
    return (
      <Question>
        <div className="title">Non-Compliance Reason(s)</div>
        {!this.state.showAddSection && !disabled && 
        <Container className="row">        
          <div className="col-sm-12">
            <WarningButton onClick={() => this.showAddSection(true)} disabled={disabled}>Add Reason</WarningButton>
          </div>      
        </Container>}
        <Container className="row">
        {this.state.showAddSection && 
          <React.Fragment>
            <div className='col-sm-6'>
              <Filter 
                onSelect={this.onReasonChange}
                items={reasons}
                title="Select Reason"
                filter={currentSelection}
                renderOption={x => <option key={x} value={x}>{x}</option>}
              />            
            </div>
            <div className='col-sm-6'>
              <WarningButton disabled={!currentSelection} onClick={this.saveReason}>Save</WarningButton>
              <span>&nbsp;</span>
              <DefaultButton onClick={this.cancelEdit}>Cancel</DefaultButton>
            </div>
          </React.Fragment>      
        }
        </Container>
      
        {selectedReasons.length > 0 && <NonComplianceReasonsList onRemove={this.removeReason} selectedReasons={selectedReasons} disabled={disabled} />}
      </Question>
      
    );
  }
}


NonComplianceReasons.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  selectedReasons: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired
};

export default NonComplianceReasons;



// WEBPACK FOOTER //
// ./src/modules/record/components/NonComplianceReasons.js